import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-invalid-label',
    templateUrl: './sera-invalid-label.component.html',
    styleUrls: ['./sera-invalid-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraInvalidLabelComponent {
    @Input()
    labelText: string = '';

    @Input()
    hasIcon: boolean = true;
}
